import React from 'react';
import styled from 'styled-components/macro';
import Slider from 'components/SlickSlider';
import {debounce, get, forEach, filter, map} from 'lodash';
import {Wrapper} from './RelatedProductsSlider.styles.js';

export const ImageWrapper = styled.div`
  max-width: 800px;
  width: 800px;
  .image {
    min-width: 100%;
    width: 800px;
    height: 500px;
  }
  .slide {
    padding: 5px !important;
  }
  .p-slick-slider-wrapper .p-slick-track {
    margin-left: 0 !important;
  }

  .p-slick-slider-wrapper .p-slick-next {
    right: -38px;
  }

  @media(max-width: 820px) {
    width: 100%;
    .mobile-view.scroll-wrapper {
      padding: 10px !important;;
      margin: 0 !important;
    }
    .image {
      min-width: 94%;    
      height: 500px;
      margin-right: 10px;
      background-size: contain !important;
    }
  }
`


export const Image = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 0px;  
  background-color: rgb(255, 255, 255);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
`



class RelatedProductsSlider extends React.Component {

  constructor(...args) {
    super(...args);
    this.resizeHandler = debounce(this.handleResize.bind(this), 20);
    this.state = {
      slidesToShow: 1,
      active: this.props.active,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeHandler);
    this.handleResize();
    this.setState({
      render: true
    });
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  handleResize(e) {
    const w = window.innerWidth;
    if (w <= 950 && !this.state.hideSlides) {
      this.setState({
        hideSlides: true,
        slidesToShow: null,
      });
    }
  }

  render() {
    let originalData = get(this.props, 'data.length') ? get(this.props, 'data') : [1,2,3,4,5,6];
    const loading = !get(this.props, 'data.length');
    const innerWidth = this.state.render ? window.innerWidth > 767 : false;
    const settings = {
      className: 'center',
      infinite: true,
      slidesToShow: this.state.slidesToShow,
      initialSlideIndex: this.state.active,
      slidesToScroll: 1,
      draggable: true,
      touchThreshold: 5000,
      speed: 300,
      arrows: true,
      pauseOnHover: innerWidth,
    };

    const ghosts = []
    forEach(originalData, (el, i) => {
       const unitWidth = get(el, 'unitWidth', 1);
       if (unitWidth && unitWidth > 1) {
        ghosts.push({ghost: true})
      }
    });

    const data = originalData.concat(ghosts)
    let itemCount = data.length;
  
    return (
      <Wrapper style={{minWidth: '100%'}}>
        <ImageWrapper>
          <div className={`p-slick-init ${loading ? 'loading' : ''} ${!this.state.render ? 'server-slick' : ''} length-${data.length} ${itemCount <= this.state.slidesToShow ? 'depleted' : ''}`}>
            {
              !this.state.hideSlides && loading ?
              <div className="desktop-view">
                {this.renderSlider(data, settings, true)}
              </div> :
              !this.state.hideSlides ?
              <div className="desktop-view">
                <div>
                  {this.renderSlider(data, settings, false)}
                </div>
              </div> :
              <div className="mobile-view scroll-wrapper">
                {
                  map(filter(data, (d) => !get(d, 'ghost')), (data, i) => {
                    return (
                      <Image key={`slide-${i}-s`} className="image" style={{backgroundImage: `url(${data.image})`}}>
      
                      </Image>
                    );
                  })
                }
              </div>
            }
          </div>
        </ImageWrapper>
      </Wrapper>
    );
  }

  renderSlider(data, settings, loading) {
    return (
      <Slider {...settings}>
        {
          map(data, (data, i) => {
            return (
              <div key={`slide-${i}-${loading}`} className="slide">
                <Image className="image" style={{backgroundImage: `url(${data.image || "https://www.mritechnologies.com/images/index-cover-rf.jpg"})`}}>
      
                </Image>
              </div>
            );
          })
        }
      </Slider>
    );
  }


}

export default RelatedProductsSlider;